import { Component } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { QaiButtonComponent } from '@qai/ui';
import { TabsInnerWrapComponent } from '../../components/tabs-inner-wrap/tabs-inner-wrap.component';
import { DetailsSectionComponent } from '../../components/details-container/details-section.component';
import { KnowledgeCheckTipsPanelComponent } from './knowledge-check-tips-panel/knowledge-check-tips-panel.component';
import { KnowledgeCheckQuestionSectionListComponent } from './knowledge-check-question-section-list/knowledge-check-question-section-list.component';
import { MessageBlockComponent } from 'src/app/components/shared/message-block/message-block.component';

@Component({
  selector: 'knowledge-check-questions-tab',
  standalone: true,
  templateUrl: './knowledge-check-questions-tab.component.html',
  styleUrls: ['./knowledge-check-questions-tab.component.scss'],
  imports: [TabsInnerWrapComponent, DetailsSectionComponent, QaiButtonComponent, TranslocoModule, KnowledgeCheckTipsPanelComponent, KnowledgeCheckQuestionSectionListComponent, MessageBlockComponent],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class KnowledgeCheckQuestionsTabComponent {}
